import { useFormik } from 'formik';
import { IGetFeedBackDetail } from 'models/IGetFeedBackDetail';
import { ISearchModel } from 'models/ISearch.Model';
import React, { useEffect, useMemo, useState } from 'react';
import { Card, Col, Container, Form, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import CommonService from 'services/CommonService';
import MasterService from 'services/Master.Service';
import * as Yup from "yup";
import { useAsyncDebounce, } from "react-table";
import { HelperConstant } from 'helpers/HelperConstant';
import StatusFilters from 'components/filter/StatusFilters';
import moment from 'moment';
import CustomLoader from 'components/Common/CustomLoader';
import StatusStatsFilters from 'components/filter/StatusStatsFilters';
import { IColumnModel } from 'models/IColumnModel';
import CustomDataTable from 'components/shared/CustomDataTable';
import { findedLocation } from 'helpers/Helper';
import UseDebounce from 'components/shared/UseDebounce';
import LocationService from 'services/Location.Service';
import { CustomDropdown } from 'components/shared/CustomDropdown';
import { CustomTextArea } from 'components/shared/CustomTextArea';
import { CustomButton } from 'components/shared/CustomButton';
import Paginate from 'components/Common/Paginate';

function FeedBack() {

    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);

    const [writeToUs, setWriteToUs] = useState<Array<any>>([]);
    const [feedback, setfeedback] = useState<IGetFeedBackDetail[]>([]);
    const [expandedCardId, setExpandedCardId] = useState<number | null>(null);
    const [editModal, setEditModal] = useState(0);
    const [selectedFeedback, setSelectedFeedback] = useState<IGetFeedBackDetail | null>(null);
    const [getFeedbackstatus, setFeedbackstatus] = useState<any>([]);
    const [search, setSearch] = useState("");
    const [searchText, setSearchText] = useState<any>();
    const [recordsCount, setRecordsCount] = useState<number>(0);
    const [disabled, setDisabled] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isStatusId, setIsStatusId] = useState(HelperConstant.Write_To_Us_StatusIds.Open);
    const [statusList, setStatusList] = useState<Array<any>>([]);
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const debouncedSearch = UseDebounce(searchText, 1000);


    const IndiaColumns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Created Date',
            accessor: 'Created',
            width: "10%",
            displayInList: true,
            Filter: true,
            datatype: "date"
        },
        {
            Header: 'Code',
            accessor: 'ContactUsCode',
            Filter: true,
            displayInList: true,
            width: "10%",
            isSortable: true,
            datatype: "linkbtn"
        },
        {
            Header: 'Name',
            accessor: 'Name',
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Mobile Number',
            accessor: 'Mobile',
            Filter: true,
            displayInList: true,
            width: "15%",
        },
        {
            Header: 'Subject',
            // accessor: 'Subject',
            accessor: (row: any) =>
                row.Subject?.length > 15
                    ? row.Subject.substring(0, 15) + "..."
                    : row.Subject,
            width: "10%",
            displayInList: true,
            Filter: true

        },
        {
            Header: 'Status',
            accessor: 'StatusName',
            Filter: true,
            displayInList: true,
            width: "10%"
        }

    ], []);

    const UaeColumns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Created Date',
            accessor: 'Created',
            width: "10%",
            displayInList: true,
            Filter: true,
            datatype: "date"
        },
        {
            Header: 'Code',
            accessor: 'ContactUsCode',
            Filter: true,
            displayInList: true,
            width: "10%",
            isSortable: true,
            datatype: "linkbtn"
        },
        {
            Header: 'Name',
            accessor: 'Name',
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Mobile Number',
            accessor: 'Mobile',
            Filter: true,
            displayInList: true,
            width: "15%",
        },
        {
            Header: 'Subject',
            //accessor: 'Subject',
            accessor: (row: any) =>
                row.Subject?.length > 15
                    ? row.Subject.substring(0, 15) + "..."
                    : row.Subject,
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Status',
            accessor: 'StatusName',
            Filter: true,
            displayInList: true,
            width: "10%"
        }
    ], []);


    const searchByText = (pageNumber: any, searchText?: any, statusId?: any) => {
        setIsLoad(true);

        let searchModel: ISearchModel = {
            offsetStart: offsetStart,
            rowsPerPage: rowsPerPage,
            sortOrder: "desc",
            sortOrderColumn: "Created",
            searchText: searchText,
            FeedbackStatusId: statusId ? parseInt(statusId) : HelperConstant.Write_To_Us_StatusIds.Open,
            FromDate: fromDate,
            ToDate: toDate,
            IsContactUs: true
        }
        CommonService.post('addressType', 'GetContactusOrCorporatetrade', searchModel).then(res => {
            if (res.status === 200) {
                setIsLoad(false);
                let data: Array<IGetFeedBackDetail> = res.data;
                setWriteToUs(data);
                setfeedback(data);
                if (res.data && res.data.length > 0) {
                    setRecordsCount(res.data[0].TotalRowsCount);
                } else {
                    setRecordsCount(0);  // Reset to zero if no data
                }
            }
        }).catch(e => console.log(e));
    }

    const pagination = (pageNumber: any) => {
        searchByText(pageNumber, debouncedSearch, isStatusId);
    }

    const handleSearch = (value: any) => {
        setSearchText(searchText);
        searchByText(0, searchText, isStatusId);
    };

    const onChange = useAsyncDebounce((value: any) => {
        handleSearch(value);
    }, 1000);

    const GetFeedbackStatus = () => {
        CommonService.post('addressType', 'GetContactFeedBackStatusCount', null).then(res => {
            if (res.status === 200) {
                setFeedbackstatus(res.data)
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const toggleShowMore = (feedbackId: number, event: React.MouseEvent) => {
        event.stopPropagation();
        setExpandedCardId(feedbackId === expandedCardId ? null : feedbackId);
    };

    const editHandler = (data: IGetFeedBackDetail) => {
        setSelectedFeedback(data);
        setEditModal(data.Id);
        formik.setValues({
            id: data.Id,
            FeedbackStatusId: data.FeedbackStatusId,
            FeedbackStatusComments: data.FeedbackStatusComments,
        });
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: 0,
            FeedbackStatusId: 0,
            FeedbackStatusComments: '',
        },
        validationSchema: Yup.object({
            FeedbackStatusId: Yup.string().notOneOf(['0'], 'Please select a Status').required("Please Select a Status").nullable(),
        }),

        onSubmit(values) {
            handleSubmit(values);
        },
    })

    const handleSubmit = (values) => {
        setDisabled(true);
        if (selectedFeedback) {
            const data = {
                Id: selectedFeedback.Id,
                FeedbackStatusId: values.FeedbackStatusId,
                FeedbackStatusComments: values.FeedbackStatusComments
            }
            CommonService.post('addressType', 'SetFeedbackAsRead', data).then((res: any) => {
                setEditModal(0);
                window.location.reload();
            })
        }
        setDisabled(false);
        setEditModal(0);
    };

    const searchHandler = (searchKeyword: any) => {
        setSearchText(searchKeyword);

        searchByText(0, searchKeyword, isStatusId);
    }

    const onColumnSortChange = (columnName, sortValue) => {
        setSelectedColumn(columnName);
        setSortOrder(sortValue);
        searchByText(0, debouncedSearch, isStatusId)
    };
    const getStatusLabel = (statusId: any) => {
        switch (statusId) {
            case HelperConstant.FeedbackStatus.Open:
                return 'Open';
            case HelperConstant.FeedbackStatus.InProgress:
                return 'InProgress';
            case HelperConstant.FeedbackStatus.Completed:
                return 'Completed';
            default:
                return '';
        }
    };

    const getStatusLabelColor = (statusname: any) => {
        switch (statusname) {
            case 1:
                return "#f1b44c";
            case 2:
                return '#556ee6';
            case 3:
                return "#34c38f"
        }
    }

    useEffect(() => {
        searchByText(0, search, isStatusId);
    }, [offsetStart, rowsPerPage, isStatusId]);


    useEffect(() => {
        searchByText(0, search, isStatusId)
        GetFeedbackStatus();
    }, []);
    return (
        <React.Fragment>
            <div className="page-content">
                <CustomLoader isOpen={isLoad} />
                <Container fluid>
                    <div className='d-flex justify-content-between'>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>WRITE TO US</h5>
                        <StatusFilters statusList={getFeedbackstatus} onClick={(id: any) => { setIsStatusId(id) }} statusName={isStatusId ? getFeedbackstatus.filter(x => x.Id == isStatusId)[0]?.Name : ""} />

                    </div>
                    <Row className='pb-3'>
                        <Col xxl={3} lg={4}>
                            <input type="search" className="form-control" id="search-bar-0" value={searchText || ""} placeholder={"Search"} onChange={e => { setSearchText(e.target.value); onChange(e.target.value) }} />
                        </Col>
                    </Row>
                    <Row>
                        {feedback.length > 0 ? 
                            feedback.map((data, idx) => (
                                <Col className='my-2' xl={4} lg={6} md={6} sm={6} xs={12} key={data.Id}>
                                    <Card onClick={() => editHandler(data)} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', borderRadius: "6px", cursor: "pointer", boxShadow: '0 4px 5px lightgray', borderLeft: `3px solid #1e4495` }} className='px-3'>
                                        <h5 className='header-text-grid fw-bold text-dofy' style={{ marginBottom: '0px', marginTop: '8px' }}>{data.Name} <span className={`badge rounded-pill`} style={{ color: '#1e4495', backgroundColor: '#e9ecef' }}>{moment(data.Created).format("MMM Do YYYY")}</span></h5>
                                        <p style={{ marginBottom: '0px', fontSize: '11px' }}>{data.Email} | {data.Mobile}</p>
                                        <p style={{ marginBottom: '0px', fontSize: '11px', fontStyle: '' }}><span style={{ fontSize: '12px', color: '#1e4495' }}>Sub:</span> {data.Subject}</p>
                                        <div>
                                            {expandedCardId === data.Id ? (
                                                <p style={{ marginBottom: '5px', whiteSpace: 'pre-wrap', fontSize: '11px' }}><span style={{ fontSize: '12px', color: '#1e4495' }}>Description: </span>{data.Description}</p>
                                            ) : (
                                                <p style={{ marginBottom: '5px', whiteSpace: 'pre-wrap', fontSize: '11px' }}><span style={{ fontSize: '12px', color: '#1e4495' }}>Description: </span>{data.Description.slice(0, 25) + (data.Description.length > 25 ? '...' : '')}</p>
                                            )}
                                            {data.Description.length > 25 && (
                                                <p onClick={(event) => toggleShowMore(data.Id, event)} style={{ alignSelf: 'flex-end', cursor: 'pointer', color: 'blue', fontSize: '10px', marginBottom: '0', marginTop: 'auto' }}>{expandedCardId === data.Id ? 'Show less' : 'Show more'}</p>
                                            )}
                                        </div>
                                        {/* {data.MarkAsRead ? ( */}
                                        <div style={{ position: 'absolute', top: '0px', right: '0px' }}>
                                            <p className="alert-btndash-feedback px-2 status-badge-mobile" style={{ backgroundColor: getStatusLabelColor(data.FeedbackStatusId) }}>
                                                {getStatusLabel(data.FeedbackStatusId)}
                                            </p>
                                        </div>
                                        {/* ) : (
                                            <div style={{ position: 'absolute', top: '9px', right: '20px' }}>
                                                <i className="bx bxs-hide" style={{ fontSize: '20px', color: '#f46a6a' }}></i>
                                            </div>
                                        )} */}
                                    </Card>
                                </Col>
                            ))
                            :
                            <Col xl={12} className='text-center'>
                            <div className="m-4">
                                <i className="bx bx-folder-open font-size-24"></i>
                                <h6 className='m-2 text-dofy fw-semibold '>No Records Found</h6>
                            </div>
                            </Col>
                        }
                        {recordsCount > 50 ? <Paginate recordsCount={recordsCount} rowName="feedbacks" rowsPerPage={rowsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} offsetStart={offsetStart} setOffsetStart={setOffsetStart} /> : ""}
                    </Row>
                    <Modal size='lg' isOpen={editModal > 0} toggle={() => setEditModal(0)} centered>
                        <ModalHeader toggle={() => setEditModal(0)}>
                            <div className=''>
                                <i className='mdi mdi-book-check-outline text-dofy me-2 font-size-17 '></i>
                                <span className='font-size-16 fw-semibold text-dofy'>Write To Us</span>
                                {selectedFeedback?.ContactUsCode && (
                                    <span className={`badge rounded-pill font-size-8 fw-bolder px-2 pt-2`} style={{ marginLeft: '20px', backgroundColor: '#e9ecef', }}>
                                        <p style={{ color: '#1e4495', fontWeight: 'bold', fontSize: '13px', marginBottom: '8px' }}>#{selectedFeedback.ContactUsCode}</p>
                                    </span>
                                )}
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <Form onSubmit={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                                return false;
                            }}>
                                {selectedFeedback && (
                                    <Container fluid style={{ padding: "0px 0px 0px 5px ", borderRadius: '13px' }}>
                                        <Row className='px-2'>
                                            <Col xl={12} lg={12} md={12} sm={12} xs={12} className="d-flex align-items-center">
                                                <i className="bx bxs-user" style={{ color: '#1e4495', marginRight: '10px', fontSize: '16px' }}></i>
                                                <p style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '0px', color: '#1e4495' }}>{selectedFeedback.Name}</p>
                                            </Col>
                                        </Row>
                                        <div style={{ backgroundColor: '#e9ecef', padding: '20px', borderRadius: '30px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', marginBottom: '10px' }}>
                                            <Row className='mb-3'>
                                                <Col xl={4} lg={4} md={4} sm={4} xs={12} className="d-flex align-items-center">
                                                    <i className="bx bx-envelope" style={{ color: '#1e4495', marginRight: '10px', fontSize: '16px' }}></i>
                                                    <p style={{ margin: 0 }}><span style={{ fontWeight: '', color: '#1e4495' }}>Email:</span> {selectedFeedback.Email}</p>
                                                </Col>
                                                <Col xl={4} lg={4} md={4} sm={4} xs={12} className="d-flex align-items-center">
                                                    <i className="bx bxs-phone" style={{ color: '#1e4495', marginRight: '10px', fontSize: '16px' }}></i>
                                                    <p style={{ margin: 0 }}><span style={{ fontWeight: '', color: '#1e4495' }}>Mobile No:</span> {selectedFeedback.Mobile}</p>
                                                </Col>
                                                <Col xl={4} lg={4} md={4} sm={4} xs={12} className="d-flex align-items-center">
                                                    <i className="bx bxs-calendar" style={{ color: '#1e4495', marginRight: '10px', fontSize: '16px' }}></i>
                                                    <p style={{ color: '#6c757d', margin: 0 }}>
                                                        <span style={{ fontWeight: '', color: '#1e4495' }}>Created:</span> {moment(selectedFeedback.Created).format("MMM Do, YYYY")}
                                                    </p>
                                                </Col>
                                            </Row>
                                            <Row className='mt-2'>
                                                <Col xl={2} lg={2} md={2} sm={2} xs={12}>
                                                    <p><i className="bx bx-book" style={{ color: '#1e4495', marginRight: '10px', fontSize: '16px' }}></i><span style={{ fontWeight: '', color: '#1e4495' }}>Subject:</span></p>
                                                </Col>
                                                <Col xl={10} lg={10} md={10} sm={10} xs={12}>
                                                    <p style={{ color: '#495057', whiteSpace: 'pre-wrap' }}>{selectedFeedback.Subject}</p>
                                                </Col>
                                            </Row>
                                            <Row className=''>
                                                <Col xl={2} lg={2} md={2} sm={2} xs={12}>
                                                    <p><i className="bx bxs-info-circle" style={{ color: '#1e4495', marginRight: '1px', fontSize: '16px' }}></i><span style={{ fontWeight: '', color: '#1e4495' }}>Description:</span></p>
                                                </Col>
                                                <Col xl={9} lg={9} md={9} sm={9} xs={12}>
                                                    <p style={{ color: '#495057', whiteSpace: 'pre-wrap' }}>"{selectedFeedback.Description}"</p>
                                                </Col>
                                            </Row>
                                        </div>
                                        <Row>
                                            <Col lg={4} className=''>
                                                <CustomDropdown
                                                    label={"FeedBack Status"}
                                                    id={"FeedbackStatusId"}
                                                    name={"FeedbackStatusId"}
                                                    value={formik.values.FeedbackStatusId}
                                                    data={getFeedbackstatus}
                                                    displayField="Name"
                                                    valueField="Id"
                                                    touched={formik.touched.FeedbackStatusId ?? false}
                                                    error={formik.errors.FeedbackStatusId}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    invalid={formik.touched.FeedbackStatusId && formik.errors.FeedbackStatusId ? true : false}
                                                    isMandatory={true} />
                                            </Col>
                                            <Col lg={8}>
                                                <CustomTextArea
                                                    name="FeedbackStatusComments"
                                                    label="Notes"
                                                    id={"FeedbackStatusCommentsId"}
                                                    value={formik.values.FeedbackStatusComments}
                                                    onBlur={formik.handleBlur}
                                                    invalid={formik.touched.FeedbackStatusComments && formik.errors.FeedbackStatusComments ? true : false}
                                                    error={formik.errors.FeedbackStatusComments}
                                                    onChange={formik.handleChange}
                                                    isMandatory={false} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col xl="12" sizeSm="11" md="12" xs="12" lg="12" className="d-flex justify-content-end">
                                                <CustomButton type={'button'} btnClassName={'btn-soft-secondary me-2'} iconClasssName={'bx bx-x font-size-14'} name={undefined} onClick={() => setEditModal(0)} />
                                                <CustomButton type={'submit'} btnClassName={'btn-success'} disabled={disabled} iconClasssName={''} name={'Save'} />
                                            </Col>
                                        </Row>
                                    </Container>
                                )}

                            </Form>
                        </ModalBody>
                    </Modal>
                </Container >
            </div >
        </React.Fragment>
    )
}

export default FeedBack
